export class CobrowseController
{
    private _isInitialized:boolean = false;

    public init():void
    {
        if (this.isInitialized())
            return;

        // below is a code snipped copied from cobrowse. It's not modified aside from formatting and typing.
        (function(w, t, c, p, s, e)
        {
            p = new Promise(function(r)
            {
                w[c] = {
                    client: function()
                    {
                        return p;
                    }
                };
                s = document.createElement(t);
                s.async = 1;
                s.src = 'https://js.cobrowse.io/CobrowseIO.js';
                e = document.getElementsByTagName(t)[0];
                e.parentNode.insertBefore(s, e);
                s.onload = function()
                {
                    r(w[c]);
                };
            });
            return p;
        })(window, 'script', 'CobrowseIO').then(function()
        {
            const CobrowseIO = (window as any).CobrowseIO;

            CobrowseIO.license = 'Shd859AwmgIAQQ';
            CobrowseIO.start();
        });

        this._isInitialized = true;
    }

    public isInitialized():boolean
    {
        return this._isInitialized;
    }
}
